// extracted by mini-css-extract-plugin
export var cardContainer = "_of-0";
export var cardHeader = "_of-2";
export var collapsedState = "_of-3";
export var dragHandle = "_of-5";
export var dragHandleIcon = "_of-6";
export var dragging = "_of-1";
export var titleArea = "_of-4";